<template>
<div id="carouselExampleSlidesOnly" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img class="d-block w-100"
      src="https://www.rocca1794.com/wp-content/uploads/IMMAGINE-SITO-1190x370_TagHeuer_banner_Rocca.jpg"
      alt="First slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100"
      src="https://cdn.shopify.com/s/files/1/0193/3758/t/23/assets/tag-heuer-watches-banner_1440x.jpg"
      alt="Second slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="/" alt="Third slide">
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'Banner',
};
</script>
<style scoped>
  img{
    padding-top: 0px;
    width: 100%;
    height: 100%;
  }
</style>
